export type OfflineMeasurementInstallationInfo = {
  measurementUuid: string;

  theBuildingIsMadeOf: string;
  theBuildingIsMadeOfComment?: string | null;
  plannedThickness: string;
  numberOfAssemblyTeams: string;
  plannedAssemblyTime: string;

  constructionSiteUuids: Array<string | { uuid: string; comment?: string }>;
  installationElementsUuids: Array<string | { uuid: string; comment?: string }>;

  updatedAt: string;
};

type OfflineMeasurementInstallationInfoState = Record<
  string,
  OfflineMeasurementInstallationInfo
>;

const STORAGE_KEY = 'offlineMeasurementInstallationInfo';

const readState = (): OfflineMeasurementInstallationInfoState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as OfflineMeasurementInstallationInfoState) || {};
  } catch (e) {
    console.error('Error reading offline measurement installation info:', e);
    return {};
  }
};

const writeState = (state: OfflineMeasurementInstallationInfoState) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('Error writing offline measurement installation info:', e);
  }
};

export const upsertOfflineMeasurementInstallationInfo = (
  info: OfflineMeasurementInstallationInfo
) => {
  const state = readState();
  writeState({
    ...state,
    [info.measurementUuid]: info,
  });
};

export const getOfflineMeasurementInstallationInfo = (
  measurementUuid: string
): OfflineMeasurementInstallationInfo | null => {
  const state = readState();
  return state[measurementUuid] || null;
};

export const clearOfflineMeasurementInstallationInfo = () => {
  writeState({});
};
